import { ButtonBase, ClickAwayListener, Grow, Tooltip } from "@mui/material";
import styles from "./styles";
import { classVeryIconGoogle } from "../../common/v2/VeryIconGoogle/classVeryIconGoogle";
import { useState, useEffect } from "react";
import { VeryBtnFill } from "../../common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../common/v2/VeryBtnFill/classVeryBtnFill";
import { VeryIconGoogle } from "../../common/v2/VeryIconGoogle";
import {
  getNotNegativeNumber,
  isPositiveInt,
  isStringEmpty,
  isValidNaturalNumber,
} from "../../../utils/handler_validations";

// Propiedades iniciales para el componente
const propsTemplate = () => ({
  textError: "",
  selectedVehicleAirbags: 0, // Renombramos a selectedVehicleAirbags para mayor claridad
  onChangeVehicleAirbags: (newAirbags = "") => {},
});

const SelectAirbags = (props = propsTemplate()) => {
  const [showMenu, setShowMenu] = useState(false);
  const [options, setOptions] = useState([2, 4, 6, 8, 10]); // Opciones realistas de cantidad de airbags

  // Cambiar la lógica según el vehículo y cantidad de airbags seleccionados
  useEffect(() => {
    if (
      props.selectedVehicleAirbags < 2 ||
      props.selectedVehicleAirbags > 10 ||
      !isValidNaturalNumber(props.selectedVehicleAirbags)
    ) {
      props.onChangeVehicleAirbags && props.onChangeVehicleAirbags(0);
      return;
    }
  }, [props.selectedVehicleAirbags]);

  const isValidSelectedAirbags = () => {
    return options.includes(props.selectedVehicleAirbags);
  };

  const renderOption = (airbags = 0) => {
    const classesCSS = ["btnAirbags"];
    if (props.selectedVehicleAirbags === airbags)
      classesCSS.push("airbagsSelected");

    return (
      <VeryBtnFill
        CSS={classesCSS}
        colorTheme={classVeryBtnFill.COLOR_THEME.WHITE_S1}
        label={`${airbags} bolsas`} // Etiqueta con la cantidad de airbags
        textSize={14}
        onClick={() => {
          setShowMenu(false);
          props.onChangeVehicleAirbags && props.onChangeVehicleAirbags(airbags);
        }}
      />
    );
  };

  return (
    <ClickAwayListener onClickAway={() => setShowMenu(false)}>
      <styles.DivMain>
        <Tooltip
          PopperProps={{ disablePortal: true }}
          open={showMenu}
          placement="bottom-start"
          disableFocusListener
          disableHoverListener
          disableTouchListener
          TransitionComponent={Grow}
          TransitionProps={{ timeout: 500 }}
          title={options.map((airbags) => renderOption(airbags))}
        >
          <div className="divSelect">
            <label className="txt-title">Bolsas de aire</label>
            <ButtonBase
              className="btnSelect"
              onClick={() => setShowMenu(!showMenu)}
            >
              <label>
                {isValidSelectedAirbags()
                  ? `${props.selectedVehicleAirbags}`
                  : "Elige cantidad de bolsas de aire"}
              </label>
              <VeryIconGoogle
                name="expand_more"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={21}
              />
            </ButtonBase>
            {!isStringEmpty(props.textError) && (
              <label className="txt-error">{props.textError}</label>
            )}
          </div>
        </Tooltip>
      </styles.DivMain>
    </ClickAwayListener>
  );
};

export default SelectAirbags;
